import { createContext } from "react"

export type EmbedTurnstileFrameConfig = {
  frameUrl: string
}

export const EmbedTurnstileFrameContext =
  createContext<EmbedTurnstileFrameConfig | null>(null)
